import { render, staticRenderFns } from "./ChatNav.vue?vue&type=template&id=2267ba02&"
import script from "./ChatNav.vue?vue&type=script&lang=js&"
export * from "./ChatNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports